(() => {
  'use strict';
  const observed = new WeakSet();
  let subscribed = false;
  function connect() {
    const host = document.getElementById('upCart');
    const exposed = window.upcartDocumentOrShadowRoot;
    const root = exposed && exposed !== document ? exposed : host?.shadowRoot || host;
    const template = document.getElementById('wam-return-template');
    if (!root || !(template instanceof HTMLTemplateElement)) return;
    const update = () => {
      const footer = root.querySelector('.upcart-footer');
      if (!footer || footer.querySelector('[data-testid="wam-upcart-returns"]')) return;
      const content = template.content.firstElementChild?.cloneNode(true);
      if (!content) return;
      content.dataset.testid = 'wam-upcart-returns';
      content.style.cssText = 'font-size:14px;line-height:1.45;color:#14342f;margin:12px 0;text-align:left;';
      content.querySelectorAll('a').forEach(link => { link.style.cssText = 'color:inherit;text-decoration:underline;'; });
      footer.prepend(content);
      footer.dataset.testid = 'wam-upcart-footer';
    };
    update();
    if (!observed.has(root)) {
      observed.add(root);
      new MutationObserver(update).observe(root, { childList: true, subtree: true });
    }
  }
  function init() {
    if (!subscribed && typeof window.upcartSubscribeCartLoaded === 'function') {
      subscribed = true;
      window.upcartSubscribeCartLoaded(connect);
      window.upcartSubscribeCartUpdated(connect);
      window.upcartSubscribeCartOpened(connect);
    }
    connect();
  }
  init();
  window.addEventListener('load', init, { once: true });
})();
